import { Teleport, computed, defineComponent, onBeforeUnmount, shallowRef, watch } from 'vue';
import classNames from '../_util/classNames';
import useNoticeTimer from './hooks/useNoticeTimer';
export default defineComponent({
    name: 'Notice',
    inheritAttrs: false,
    props: [
        'prefixCls',
        'duration',
        'updateMark',
        'noticeKey',
        'closeIcon',
        'closable',
        'props',
        'onClick',
        'onClose',
        'holder',
        'visible',
        'showProgress',
        'pauseOnHover',
    ],
    setup(props, { attrs, slots }) {
        let isUnMounted = false;
        const duration = computed(() => (props.duration === undefined ? 4.5 : props.duration));
        const pauseOnHover = computed(() => props.pauseOnHover !== false);
        const percent = shallowRef(0);
        const close = (e) => {
            if (e) {
                e.stopPropagation();
            }
            if (isUnMounted) {
                return;
            }
            const { onClose, noticeKey } = props;
            if (onClose) {
                onClose(noticeKey);
            }
        };
        const { onResume, onPause, reset } = useNoticeTimer(duration, () => close(), ptg => {
            percent.value = ptg;
        });
        watch([() => props.updateMark, () => props.visible], ([updateMark, visible], [prevUpdateMark, prevVisible]) => {
            if (updateMark !== prevUpdateMark || (visible !== prevVisible && visible)) {
                reset();
            }
        }, { flush: 'post' });
        onBeforeUnmount(() => {
            isUnMounted = true;
        });
        const onMouseEnter = () => {
            if (pauseOnHover.value) {
                onPause();
            }
        };
        const onMouseLeave = () => {
            if (pauseOnHover.value) {
                onResume();
            }
        };
        return () => {
            var _a, _b;
            const { prefixCls, closable, closeIcon = (_a = slots.closeIcon) === null || _a === void 0 ? void 0 : _a.call(slots), onClick, holder } = props;
            const { class: className, style } = attrs;
            const componentClass = `${prefixCls}-notice`;
            const dataOrAriaAttributeProps = Object.keys(attrs).reduce((acc, key) => {
                if (key.startsWith('data-') || key.startsWith('aria-') || key === 'role') {
                    acc[key] = attrs[key];
                }
                return acc;
            }, {});
            const validPercent = 100 - Math.min(Math.max(percent.value * 100, 0), 100);
            const showProgressBar = !!props.showProgress && typeof duration.value === 'number' && duration.value > 0;
            const node = (<div class={classNames(componentClass, className, {
                    [`${componentClass}-closable`]: closable,
                })} style={style} onMouseenter={onMouseEnter} onMouseleave={onMouseLeave} onClick={onClick} {...dataOrAriaAttributeProps}>
          <div class={`${componentClass}-content`}>{(_b = slots.default) === null || _b === void 0 ? void 0 : _b.call(slots)}</div>
          {closable ? (<a tabindex={0} onClick={close} class={`${componentClass}-close`}>
              {closeIcon || <span class={`${componentClass}-close-x`}/>}
            </a>) : null}
          {showProgressBar ? (<progress class={`${componentClass}-progress`} max={100} value={validPercent}/>) : null}
        </div>);
            if (holder) {
                return <Teleport to={holder} v-slots={{ default: () => node }}></Teleport>;
            }
            return node;
        };
    },
});
